import React from 'react';
import { Outlet } from 'react-router';
import { useTrackPageVisitEvent } from 'shared/hooks/use-track-page-visit-event';
import { PageEvents } from 'shared/services/tracking';

import { PageTopBar } from './components/page-top-bar';
import * as Styled from './goal-detail.style';

export const GoalDetail: React.FC = () => {
  useTrackPageVisitEvent(PageEvents.GoalsDetail, undefined);

  return (
    <Styled.Container>
      <Styled.Main>
        <PageTopBar />

        <Outlet />
      </Styled.Main>
    </Styled.Container>
  );
};
